<template>
  <div class="inter-wrapper">
    <HeaderInter />
    <!-- 填寫資料 -->
    <div v-if="detail" class="inter-content container-fluid">
      <vsa-list :init-active="true" :auto-collapse="false" >
        <vsa-item>
          <vsa-heading> {{ $langt('訂單資訊') }} </vsa-heading>
          <vsa-content>
            <div class="content-wrap">
              <div class="order-area">
                <div class="box-group">
                  <div class="order-cancel" v-if="detail.show_refund">
                    <button @click="showModal = true">{{ $langt('取消') }}</button>
                  </div>
                  <div>
                  </div>
                  <div class="box-items">
                    <div class="box-th">
                      {{ $langt('訂單編號') }}
                    </div>
                    <div class="box-td">
                      {{ detail.order_num }}
                    </div>
                  </div>
                  <div class="box-items">
                    <div class="box-th">
                      {{ $langt('訂購日期') }}
                    </div>
                    <div class="box-td">
                      {{ detail.create_at.substring(0, 10) }}
                    </div>
                  </div>
                  <div class="box-items" v-if="detail.booking_time">
                    <div class="box-th">
                      {{ $langt('預訂時間') }}
                    </div>
                    <div class="box-td">
                      {{ detail.booking_time }}
                    </div>
                  </div>
                  <div class="box-items">
                    <div class="box-th">
                      {{ $langt('支付方式') }}
                    </div>
                    <div class="box-td">
                      {{ paymentNameLabel }}
                    </div>
                  </div>
                  <div class="box-items box-items__inv">
                    <div class="box-th">
                      {{ $langt('發票種類') }}
                    </div>
                    <div class="box-td">
                      {{ invoiceTypeName }}
                      <div v-if="detail.inv_type === '3' && detail.inv_data.inv_uni_title">
                        <p>{{ `${$langt('發票抬頭')}: ${detail.inv_data.inv_uni_title}` }}</p>
                        <p>{{ `${$langt('發票統編')}: ${detail.inv_data.inv_uni_num}` }}</p>
                      </div>
                      <div v-if="detail.inv_type === '5' && detail.inv_data.inv_uni_title">
                        <p>{{ `Company Name: ${detail.inv_data.inv_uni_title}` }}</p>
                        <p>{{ `VAT/GST Number: ${detail.inv_data.inv_uni_num}` }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="box-items">
                    <div class="box-th">
                      {{ $langt('訂單備註') }}
                    </div>
                    <div class="box-td nl2br" v-text="detail.remark" />
                  </div>
                  <div class="box-items">
                    <div class="box-th">
                      {{ $langt('訂單金額') }}
                    </div>
                    <div class="box-td">
                      <span>{{ detail.use_point }}</span>{{ $langt('點') }} ＋ {{ detail.currency_code | currencyTitle }}<span>{{ detail.fee_total | priceFormat(detail.currency_code) }}</span>
                    </div>
                  </div>
                  <!-- 退款金額 -->
                  <div class="box-items" v-if="detail.is_cancel === 't' || detail.is_refund === 't' || detail.is_refunding || detail.is_refunding_confirm">
                    <div class="box-th">
                      {{ $langt('退款金額') }}
                    </div>
                    <div class="box-td">
                      <template v-if="detail.is_cancel === 't' || detail.is_refund === 't'">
                        {{ detail.currency_code | currencyTitle }}<span>{{ detail.refund_amt | priceFormat(detail.currency_code) }}</span>
                      </template>
                      <template v-else >
                        <div>{{ $langt('退貨處理中') }}</div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-for="(item, index) in detail.voucher"
                :key="index"
                class="order-area-deatil"
              >
                <div class="sn">
                  {{ index + 1 }}.
                </div>
                <div class="name">
                  {{ item.item_name }}
                </div>
                <div class="iteme">
                  {{ item.plan_name }}{{ detail.items[0].price_name | pricename }}
                  <span
                    v-if="
                      detail.items[0].refund_type &&
                        detail.items[0].refund_type.toString() === '2'
                    "
                    class="refundtext"
                  >
                    {{ $langt('不可取消') }}
                  </span>
                </div>
                <div class="state">
                  <p :class="getStatusClass(item)">
                    {{ getStatusLabel(item) }}
                  </p>
                  <div
                    v-if="detail.is_voucher && detail.is_cancel !== 't'"
                    class="out-line"
                  >
                    <a @click="toVoucherDetail(item)">{{ $langt('查看票券') }}</a>
                  </div>
                </div>
              </div>
            </div>
          </vsa-content>
        </vsa-item>
      </vsa-list>

      <vsa-list>
        <vsa-item>
          <vsa-heading> {{ $langt('聯絡人資訊') }} </vsa-heading>
          <vsa-content>
            <div class="content-wrap">
              <div class="contact-info">
                <ul>
                  <li class="contact-border">{{ $langt('姓名') }}</li>
                  <li>{{ detail.bill_name }}</li>
                  <li class="contact-border">{{ $langt('電話') }}</li>
                  <li>{{ detail.bill_phone }}</li>
                  <li class="contact-border">{{ $langt('信箱') }}</li>
                  <li>{{ detail.bill_email }}</li>
                </ul>
              </div>
            </div>
          </vsa-content>
        </vsa-item>
      </vsa-list>
      <vsa-list v-if="detail.items && detail.items.length > 0 && detail.items[0].product_request && detail.items[0].product_request['1']">
        <vsa-item>
          <vsa-heading>{{ $langt('使用人資訊')}}({{$langt('旅客')}})</vsa-heading>
          <vsa-content>
            <div class="content-wrap">
              <div class="contact-info">
                  <div v-for="(traveler, tIndex) in detail.items[0].product_request['1']" :key="tIndex">
                    <div v-for="(field, fIndex) in traveler" :key="fIndex">
                      <div class="contact-border">{{$langt('旅客')}}{{ tIndex + 1 }} - {{ field.name[0] }}</div>
                      <div>{{ field.value[0] }}</div>
                    </div>
                  </div>
              </div>
            </div>
          </vsa-content>
        </vsa-item>
      </vsa-list>
      <vsa-list v-if="detail.items && detail.items.length > 0 && detail.items[0].product_request && detail.items[0].product_request['2']">
        <vsa-item>
          <vsa-heading>{{ $langt('使用人資訊')}}({{$langt('訂單')}})</vsa-heading>
          <vsa-content>
            <div class="content-wrap">
              <div class="contact-info">
                <div v-for="(item, index) in detail.items[0].product_request['2']" :key="'item2-'+index">
                  <div class="contact-border">{{ item.name[0] }}</div>
                  <div>{{ item.value.join('、') }}</div>
                </div>
              </div>
            </div>
          </vsa-content>
        </vsa-item>
      </vsa-list>
      <vsa-list v-if="detail.is_shipment === 't'">
        <vsa-item>
          <vsa-heading> {{ $langt('收件人資訊') }} </vsa-heading>
          <vsa-content>
            <div class="content-wrap">
              <div class="contact-info">
                <ul>
                  <li>{{ $langt('收件人姓名') }}：{{ detail.ship_name }}</li>
                  <li>{{ $langt('收件人電話') }}：{{ `${detail.ship_country_code || ''} ${detail.ship_phone}` }}</li>
                  <li>{{ $langt('收件人地址') }}：{{ `${detail.ship_region} ${detail.ship_addr}` }}</li>
                  <template v-if="detail.is_deliver === 't'">
                    <li>{{ $langt('物流名稱') }}：{{ detail.delivery_name }}</li>
                    <li>{{ $langt('物流編號') }}：{{ detail.delivery_num }}</li>
                    <li v-if="detail.delivery_link">
                      {{ $langt('物流查詢網址') }}：
                      <a :href="detail.delivery_link" target="_blank" rel="noopener noreferrer">
                        {{ detail.delivery_link }}
                      </a>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </vsa-content>
        </vsa-item>
      </vsa-list>
      <vsa-list v-if="$store.getters.shopInfo">
        <vsa-item>
          <vsa-heading>
            {{ $langt('取消政策') }}
          </vsa-heading>
          <vsa-content>
            <div class="content-wrap">
              <div class="main">
                  <dd
                    class="nl2br"
                    v-text="detail.policy_cancel"
                  />
              </div>
            </div>
          </vsa-content>
        </vsa-item>
      </vsa-list>
          <div class="contact-fix">
            <button class="btn btn-next" type="button" @click="toContact()">
              {{ $langt('聯絡客服') }}
            </button>
          </div>
    </div>
    <!-- 彈窗 -->
    <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
      <div class="modal-content">
        <h4>{{ $langt('取消') }}</h4>
        <p>{{ $langt('是否要取消此筆訂單?') }}</p>
        <p>{{ $langt('原金額為') }}<span>{{ detail.currency_code | currencyTitle }}{{ detail.fee_total | priceFormat(detail.currency_code) }}</span></p>
        <p>{{ $langt('取消可退還') }}<span>{{ detail.currency_code | currencyTitle }}{{detail.can_refund_amt | priceFormat(detail.currency_code)}}</span></p>
        <div class="modal-button">
          <button @click="cancelOrder(detail.order_id)" class="modal-btn1">{{ $langt('確定') }}</button>
          <button @click="showModal = false" class="modal-btn2">{{ $langt('關閉') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInter from '@/components/HeaderInter'
import { getOrder } from '@/api/order'
import { refundOrder } from '@/api/order'
import { VsaList, VsaItem, VsaHeading, VsaContent } from 'vue-simple-accordion'

export default {
  name: 'OrderFinish',
  components: {
    HeaderInter,
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent
  },
  data() {
    const contactForm = {
      from_name: null,
      from_email: null,
      content: null,
      order_id: null
    }

    return {
			isLoading: false,
      showModal: false,
      showCancelDetail: false, // 控制是否顯示取消金額區塊
      detail: false,
      contactForm: contactForm,
      // READY 準備中 DONE 已取得憑証 CANCEL 作廢
      voucherStatus: {
        READY: this.$langt('準備中'),
        DONE: this.$langt('已取得憑証'),
        REDEEM: this.$langt('已使用'),
        CANCEL: this.$langt('作廢')
      }
    }
  },
  computed: {
    paymentNameLabel: function() {
      const point = parseInt(this.detail.use_point)
      return this.detail.paytype_name_web + (point === 0 ? '' : (' + ' + this.$langt('點數')))
    },
    invoiceTypeName: function() {
      // 1 電子發票二聯 2 二聯紙本 3 電子發票三聯 4 捐贈 5電子收據
      switch (this.detail.inv_type) {
        case '1':
          return this.$langt('電子發票二聯')
        case '2':
          return this.$langt('二聯紙本')
        case '3':
          return this.$langt('電子發票三聯')
        case '4':
          return this.$langt('捐贈')
        case '5':
          return this.$langt('電子收據')
        default:
          return '-'
      }
    }
  },
  created() {
    getOrder(this.$route.params.num, {}).then(response => {
      this.detail = response.data.data
    })
  },
  mounted() {},
  methods: {
    getStatusLabel(item) {
      return this.voucherStatus[item.status] !== undefined
        ? this.voucherStatus[item.status]
        : '-'
    },
    getStatusClass(item) {
      // READY 準備中 DONE 已取得憑証 CANCEL 作廢
      switch (item.status) {
        case 'READY':
          return 'pending'
        case 'DONE':
        case 'REDEEM':
          return 'accepted'
        case 'CANCEL':
          return 'refunded'
        default:
          return 'pending'
      }
    },
    toContact() {
      this.$router.push('/contact/ask/' + this.detail.order_num)
    },
    toVoucherDetail(item) {
      this.$router.push('/voucher/detail/' + item.voucher_num)
    },
    cancelOrder(num) {
      // 呼叫後端取消 API
      this.showModal = false
      this.$store.commit('SET_LOADING', true)
      refundOrder(num, this.detail)
      .then((response) => {
      })
      .catch(() => {
      })
      .finally(() => {
        this.$store.commit('SET_LOADING', false) // 關閉 loading
        window.location.reload() // 整頁刷新
      })
      

    }
    
  }
}
</script>

<style  lang="scss">
@import 'assets/scss/common.scss';
.content-wrap {
  padding: 0 15px;
}
// 彈窗
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.modal-content {
  background: $white-color;
  padding: 20px;
  border-radius: 6px;
  width: 40%;
  min-width: 300px;
  span{
    color: $price-color;
    margin-left: 10px;
		font-weight: bold;
  }
  .modal-button{
    display: flex;
    justify-content: flex-end;
    button{
      border: none;
      margin: 0 5px;
      width: 80px;
    }
    .modal-btn1{
      background-color: $living_item;
      color: $white-color;
    }
    .modal-btn2{
      background-color: $white-color;
      color: gray;
      border: 1px solid gray;
    }

  }
}
.order-area {
  // padding: 0 15px;
  margin-bottom: 10px;
  .box-group {
    .order-cancel{
      margin-bottom: 10px;
      button{
        font-weight: bold;
        color: white;
        background-color: rgb(223, 111, 111);
        border:none;
        min-width: 80px;
        max-width: 120px;
        height: 30px;
      }
      button:hover{
        color: rgb(223, 111, 111);
        background-color: white;
        border: 2px solid rgb(223, 111, 111);
      }
    }
    .box-items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.25rem;
      .box-th {
        padding: 5px 15px 5px 0px;
        white-space: nowrap;
      }
      .box-td {
        text-align: right;
        padding-left: 10px;
        span {
          color: rgba($main-color, $alpha: 1);
          font-weight: bolder;
        }
      }
    }

    .box-items__inv {
      align-items: flex-start;
      p {
        margin-bottom: 0;
      }
    }
  }
  .box-article {
    font-size: 1rem;
    line-height: 1.85rem;
    color: rgba($font-color, $alpha: 1);
    padding-bottom: 2rem;
  }
}

.order-area-deatil {
  border-top: 1px solid rgba($font-color, $alpha: 0.35);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.5rem 0;
  .sn {
    flex: 0 0 calc(5%);
  }
  .name {
    flex: 0 0 calc(45% - 15px);
  }
  .iteme {
    flex: 0 0 calc(30% - 15px);
  }
  .state {
    flex: 0 0 20%;
    p {
      padding: 0.15rem 0.35rem;
      margin: 0;
    }
    p.accepted {
      border: 1px solid rgba($notice-color, $alpha: 0.65);
      color: rgba($notice-color, $alpha: 0.65);
      text-align: center;
      border-radius: 55px;
    }
    p.pending {
      background: rgba($notice-color, $alpha: 0.65);
      color: rgba($white-color, $alpha: 1);
      text-align: center;
      border-radius: 55px;
    }
    p.shipped {
      background: rgba($notice-color, $alpha: 1);
      color: rgba($white-color, $alpha: 1);
      text-align: center;
      border-radius: 55px;
    }
    p.refunded {
      background: rgba($font-color, $alpha: 1);
      color: rgba($white-color, $alpha: 1);
      text-align: center;
      border-radius: 55px;
    }
    p.refunded-text {
      color: rgba($font-color, $alpha: 1);
    }
    .out-line {
      color: rgba($main-color, $alpha: 1);
      margin-top: 0.65rem;
      border-radius: 50px;
      text-align: center;
      a {
        color: rgba($main-color, $alpha: 1);
      }
    }
  }
}

.main {
  p {
    margin: 0 0 0.5rem;
    padding: 0;
  }
  dl {
    padding-bottom: 1rem;
  }
  dt {
    color: $main-color;
    margin-bottom: 0.35rem;
  }
  dd {
    font-size: 1rem;
    line-height: 1.85rem;
    margin: 0;
    padding: 0;
  }
  dd span {
    color: $sec-color;
  }
}
.contact-info {
  line-height: 1.85rem;
  margin: 0;
  padding: 0;
  ul {
    line-height: 1.85rem;
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
.contact-fix {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 68px;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  z-index: 999;
  color: rgba($main-color, $alpha: 1);
  background: rgba($white-color, $alpha: 1);
  box-shadow: 0px -10px 20px 0px rgba($main-color, $alpha: 0.35);
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: opacity 0.8s linear;
  .info-box {
    display: flex;
    flex-direction: column;
    color: rgba($font-color, $alpha: 1);
    line-height: 1rem;
    em {
      font-style: normal;
      big {
        color: rgba($notice-color, $alpha: 1);
        padding: 0 3px 0 0;
        font-size: 1.15rem;
        font-weight: bolder;
      }
    }
  }
  .btn {
    flex: 0 0 100%;
    font-size: 1rem;
    border-radius: 0;
    padding: 12px;
  }
  .btn-next {
    background: rgba($main-color, $alpha: 1);
    color: $white-color;
  }
}
.form-area {
  display: flex;
  flex-direction: column;
  .btn {
    flex: 0 0 100%;
    border-radius: 0;
    padding: 10px;
  }
  .btn-next {
    background: rgba($main-color, $alpha: 1);
    color: $white-color;
  }
}

.isscroll {
  .contact-fix {
    opacity: 0;
  }
}

.refundtext {
  display: inline;
  line-height: 1;
  background-color: $price-color;
  color: white;
  font-weight: 700;
  border-radius: 4px;
  font-size: 12px;
  padding: 3px 8px;
  white-space: nowrap;
}

.contact-border{
  border-bottom: 1px solid #D3D3D3;
  color: var(--main-color);
}

@media screen and (min-width: 640px) {
  .contact-fix {
    max-width: 640px;
  }
}
@media screen and (min-width: 768px) {
  .contact-fix {
    max-width: 768px;
  }
}
</style>